import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralizeUnit',
  standalone: true,
})
export class PluralizeUnitPipe implements PipeTransform {
  transform(unit: string | null | undefined): string {
    if (!unit) {
      return '';
    }

    const lowerUnit = unit.toLowerCase();
    if (lowerUnit.includes('gal')) {
      return unit;
    }
    if (lowerUnit.includes('gallon')) {
      return unit.replace(/gallons/i, 'gallon');
    }
    if (lowerUnit.includes('yard') && !lowerUnit.includes('yards')) {
      return unit.replace(/yard/i, (match) => match + 's');
    }

    return unit;
  }
}
